module.exports = __webpack_public_path__ + "img/streak200.6f6dcec1.png";